import { DrawerCreatableSingleSelectField, DrawerHeader, DrawerHeading, laravelSelectFetchConfig } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { CreateCompanyDrawerContent } from "../companies/create/CreateCompanyDrawer";
import { useCompany } from "../companies/create/useCompany";
import { companyService } from "../shared/api/companyService";
import { CompanyCreateRequest, ICompanyOptionResource } from "../shared/types";

const getName = (option: ICompanyOptionResource) => option.name;

const fetchConfig = laravelSelectFetchConfig(companyService.optionsKey, (search, page) =>
	companyService.options(search, page).then((x) => x.data),
);

interface Props {
	label: string;
	name: string;
	required?: boolean;
	disabled?: boolean;
	clearable?: boolean;
}

export const CreatableCompanySelect: FC<Props> = ({ label, name, required, disabled, clearable }) => {
	const { createCompany, showCompany } = useCompany();
	const { t } = useTranslation();

	const handleCreate = async (
		values: CompanyCreateRequest,
		selectNewOption: (company: ICompanyOptionResource) => void,
		onClose: () => void,
	) => {
		const id = await createCompany(values);

		if (id) {
			const data = await showCompany(id);
			data && selectNewOption(data);
			onClose();
		}
	};

	return (
		<DrawerCreatableSingleSelectField
			clearable={clearable}
			label={label}
			name={name}
			getLabel={getName}
			fetchConfig={fetchConfig}
			required={required}
			disabled={disabled}
			onCreate={(selectNewOption, onClose, search) => (
				<>
					<DrawerHeader onClose={onClose}>
						<DrawerHeading>{t("Add company")}</DrawerHeading>
					</DrawerHeader>
					<CreateCompanyDrawerContent
						onSubmit={(values) => handleCreate(values, selectNewOption, onClose)}
						name={search}
					/>
				</>
			)}
		/>
	);
};
